import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=531cac1a&"
import script from "./activityDetails.vue?vue&type=script&lang=js&"
export * from "./activityDetails.vue?vue&type=script&lang=js&"
import style0 from "./activityDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports